/*
 * @Author: wita.wang 
 * @Date: 2022-08-02 10:53:38 
 * @Last Modified by: wita.wang
 * @Last Modified time: 2022-08-02 10:54:03
 */

export default class pageUtil{
    
    /**
     * 做分页请求静态数据
     * @param {*} pageNum 
     * @param {*} perPage 
     * @param {*} array 
     */
    getStaticPage(pageNum,perPage,arrayItemsIn){
        let arrayItems = JSON.parse(JSON.stringify(arrayItemsIn));
        let startIndex =  0;
        let returnArray = [];
        if(pageNum > 0){
            startIndex = (pageNum - 1) * perPage;
            returnArray = arrayItems.splice(startIndex,perPage);
        }
        return returnArray;
    }
    /**
     * 获得总页数
     * @param {*} totalnum 总数目
     * @param {*} perPage 每页条数
     * @returns 
     */
    getPageCount(totalnum,perPage){
        return totalnum > 0 ? ((totalnum < perPage) ? 1 : ((totalnum % perPage) ? (parseInt(totalnum / perPage) + 1) : (totalnum / perPage))) : 0;
    }
    /**
     * 打开新页签，保持vuex状态
     * @param {} route 
     * @param {*} _this 
     */
    openNewPage(_this,route){
        //打开新页面时，需要将状态存储
        sessionStorage.setItem("store", JSON.stringify(_this.$store.state));
        window.open(route,'_blank');
    }
    /**
     * 状态持久化
     * @param {*} _this 
     */
    initStateStore(_this){
        if (sessionStorage.getItem("store")) {
            _this.$store.replaceState(
              Object.assign(
               {},
               _this.$store.state,
               JSON.parse(sessionStorage.getItem("store"))
              )
            );
           //刷新完成之后数据存在vuex里，然后再把浏览器sessionStorage数据删除，这样相对安全些
            sessionStorage.clear()
          }
          //在页面刷新时将vuex里的信息保存到sessionStorage里
          window.addEventListener("beforeunload", () => {
            sessionStorage.setItem("store", JSON.stringify(_this.$store.state));
          });
    }
    

    

}